var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-panel"},[_c('div',{staticClass:"floating-panel-header",on:{"click":_vm._onclick}}),_c('div',{staticClass:"floating-panel-content",style:({ height: _vm.height + 'vh' })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }